import { render, staticRenderFns } from "./ResetByEmail.vue?vue&type=template&id=50ae2420&scoped=true&"
import script from "./ResetByEmail.vue?vue&type=script&lang=js&"
export * from "./ResetByEmail.vue?vue&type=script&lang=js&"
import style0 from "./ResetByEmail.vue?vue&type=style&index=0&id=50ae2420&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae2420",
  null
  
)

export default component.exports